// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AlignmentData-module__font-s-10___ckCS_ {
  font-size: 10px !important;
}

.AlignmentData-module__font-s-12___ExBx4 {
  font-size: 12px !important;
}

.AlignmentData-module__font-s-13___cIVyn {
  font-size: 13px !important;
}

.AlignmentData-module__font-s-14___drJYM {
  font-size: 14px !important;
}

.AlignmentData-module__font-s-15___vlAGI {
  font-size: 15px !important;
}

.AlignmentData-module__font-s-16___KPIH9 {
  font-size: 16px !important;
}

.AlignmentData-module__font-s-18___BnYgN {
  font-size: 18px !important;
}

.AlignmentData-module__font-s-20___YPVDd {
  font-size: 20px !important;
}

.AlignmentData-module__font-s-22___zeZm_ {
  font-size: 22px !important;
}

.AlignmentData-module__font-s-28___vBbtY {
  font-size: 28px !important;
}

.AlignmentData-module__font-w-400___Jijur {
  font-weight: 400 !important;
}

.AlignmentData-module__font-w-500___T6FDp {
  font-weight: 500 !important;
}

.AlignmentData-module__font-w-600___fHF1b {
  font-weight: 600 !important;
}

.AlignmentData-module__font-w-700___bsLPP {
  font-weight: 700 !important;
}

.AlignmentData-module__p-5___ie6Fj {
  padding: 5px !important;
}

.AlignmentData-module__p-12___WyWM9 {
  padding: 12px !important;
}

.AlignmentData-module__p-16___Dh68Q {
  padding: 16px !important;
}

.AlignmentData-module__p-30___n0HNn {
  padding: 30px !important;
}

.AlignmentData-module__p-b-0___ufUq0 {
  padding-bottom: 0 !important;
}

.AlignmentData-module__p-b-5___Bl65q {
  padding-bottom: 5px !important;
}

.AlignmentData-module__p-b-10___H6L4f {
  padding-bottom: 10px !important;
}

.AlignmentData-module__p-b-12___xl7ZE {
  padding-bottom: 12px !important;
}

.AlignmentData-module__p-b-16___kj_rE {
  padding-bottom: 16px !important;
}

.AlignmentData-module__p-b-18___q4R3Z {
  padding-bottom: 18px !important;
}

.AlignmentData-module__p-b-20____h8xt {
  padding-bottom: 20px !important;
}

.AlignmentData-module__p-b-25___sqffR {
  padding-bottom: 25px !important;
}

.AlignmentData-module__p-b-30___RaFfb {
  padding-bottom: 30px !important;
}

.AlignmentData-module__p-b-50___yXL7X {
  padding-bottom: 50px !important;
}

.AlignmentData-module__p-t-0___fpGtJ {
  padding-top: 0 !important;
}

.AlignmentData-module__p-t-12___sWD_q {
  padding-top: 12px !important;
}

.AlignmentData-module__p-t-16___Yqkyc {
  padding-top: 16px !important;
}

.AlignmentData-module__p-t-18___rxoez {
  padding-top: 18px !important;
}

.AlignmentData-module__p-t-20___YT6B2 {
  padding-top: 20px !important;
}

.AlignmentData-module__p-t-30___y5PKb {
  padding-top: 30px !important;
}

.AlignmentData-module__p-t-40___qr71g {
  padding-top: 40px !important;
}

.AlignmentData-module__p-t-50___zQrSn {
  padding-top: 50px !important;
}

.AlignmentData-module__p-l-20___akMpa {
  padding-left: 20px !important;
}

.AlignmentData-module__p-l-30___nNfrF {
  padding-left: 30px !important;
}

.AlignmentData-module__p-l-40___pKWUG {
  padding-left: 40px !important;
}

.AlignmentData-module__p-r-16___m1WQl {
  padding-right: 16px !important;
}

.AlignmentData-module__p-r-20___QTL2o {
  padding-right: 20px !important;
}

.AlignmentData-module__p-r-30___rzCQC {
  padding-right: 30px !important;
}

.AlignmentData-module__p-r-50___aZ1yl {
  padding-right: 50px !important;
}

.AlignmentData-module__p-r-60___uPuD3 {
  padding-right: 60px !important;
}

.AlignmentData-module__m-b-1___HGak1 {
  margin-bottom: 1px !important;
}

.AlignmentData-module__m-b-2___nhVvt {
  margin-bottom: 2px !important;
}

.AlignmentData-module__m-b-6___VIjwJ {
  margin-bottom: 6px !important;
}

.AlignmentData-module__m-b-8___pP6KZ {
  margin-bottom: 8px !important;
}

.AlignmentData-module__m-b-10___cTYWf {
  margin-bottom: 10px !important;
}

.AlignmentData-module__m-b-14___vKCZt {
  margin-bottom: 14px !important;
}

.AlignmentData-module__m-b-16___ROH8J {
  margin-bottom: 16px !important;
}

.AlignmentData-module__m-b-20___FmAoJ {
  margin-bottom: 20px !important;
}

.AlignmentData-module__m-b-22___lrM_1 {
  margin-bottom: 22px !important;
}

.AlignmentData-module__m-b-24___yS43O {
  margin-bottom: 24px !important;
}

.AlignmentData-module__m-b-30___p69Pn {
  margin-bottom: 30px !important;
}

.AlignmentData-module__m-b-32___OTpit {
  margin-bottom: 32px !important;
}

.AlignmentData-module__m-b-40___lyxdm {
  margin-bottom: 40px !important;
}

.AlignmentData-module__m-t-2___M4dAk {
  margin-top: 2px !important;
}

.AlignmentData-module__m-t-3___o9KXv {
  margin-top: 3px !important;
}

.AlignmentData-module__m-t-4___kLIgV {
  margin-top: 4px !important;
}

.AlignmentData-module__m-t-5___S0qoM {
  margin-top: 5px !important;
}

.AlignmentData-module__m-t-8___nAsxR {
  margin-top: 8px !important;
}

.AlignmentData-module__m-t-10___M88nu {
  margin-top: 10px !important;
}

.AlignmentData-module__m-t-15____SWv_ {
  margin-top: 15px !important;
}

.AlignmentData-module__m-t-16___iJ0ue {
  margin-top: 16px !important;
}

.AlignmentData-module__m-t-20___BmJGX {
  margin-top: 20px !important;
}

.AlignmentData-module__m-t-22___NNDea {
  margin-top: 22px !important;
}

.AlignmentData-module__m-t-30___hOb_k {
  margin-top: 30px !important;
}

.AlignmentData-module__m-t-32___yJpr2 {
  margin-top: 32px !important;
}

.AlignmentData-module__m-l-auto___B0WBl {
  margin-left: auto !important;
}

.AlignmentData-module__m-l-4___cYMzR {
  margin-left: 4px !important;
}

.AlignmentData-module__m-l-5___TCz14 {
  margin-left: 5px !important;
}

.AlignmentData-module__m-l-6___lR9rL {
  margin-left: 6px !important;
}

.AlignmentData-module__m-l-8___l21c1 {
  margin-left: 8px !important;
}

.AlignmentData-module__m-l-10___Dufvb {
  margin-left: 10px !important;
}

.AlignmentData-module__m-l-16___YCnXO {
  margin-left: 16px !important;
}

.AlignmentData-module__m-l-20___ax7Gt {
  margin-left: 20px !important;
}

.AlignmentData-module__m-l-24___IYeSV {
  margin-left: 24px !important;
}

.AlignmentData-module__m-l-30___F8hFp {
  margin-left: 30px !important;
}

.AlignmentData-module__m-l-35___i_k6V {
  margin-left: 35px !important;
}

.AlignmentData-module__m-l-40___qCaZ3 {
  margin-left: 40px !important;
}

.AlignmentData-module__m-r-8___TDwW5 {
  margin-right: 8px !important;
}

.AlignmentData-module__m-r-10___wGqB6 {
  margin-right: 10px !important;
}

.AlignmentData-module__m-r-16___kgQ5M {
  margin-right: 16px !important;
}

.AlignmentData-module__m-r-20___w_mNZ {
  margin-right: 20px !important;
}

.AlignmentData-module__m-r-24___BFxpd {
  margin-right: 24px !important;
}

.AlignmentData-module__m-r-30___TFxdw {
  margin-right: 30px !important;
}

.AlignmentData-module__m-r-40___uCriP {
  margin-right: 40px !important;
}

.AlignmentData-module__border-r-3___bPAln {
  border-radius: 3px !important;
}

.AlignmentData-module__border-r-4___PwTTi {
  border-radius: 4px !important;
}

.AlignmentData-module__border-r-6___zBeeP {
  border-radius: 6px !important;
}

.AlignmentData-module__border-r-10___EqSqh {
  border-radius: 10px !important;
}

.AlignmentData-module__border-r-12___VJjPH {
  border-radius: 12px !important;
}

.AlignmentData-module__border-r-16___RGMJC {
  border-radius: 16px !important;
}

.AlignmentData-module__border-r-50___MnRfm {
  border-radius: 50% !important;
}

.AlignmentData-module__primary-border___xS_af {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.AlignmentData-module__primary-border-b___t1Cmt {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.AlignmentData-module__primary-border-t___cHkOH {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.AlignmentData-module__primary-border-l___SrXkK {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.AlignmentData-module__primary-border-r___M4iKH {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.AlignmentData-module__secondary-border____JBU8 {
  border: 1px solid #637768;
}

.AlignmentData-module__secondary-border-b___R1AlQ {
  border-bottom: 1px solid #637768;
}

.AlignmentData-module__secondary-border-t___UNiop {
  border-top: 1px solid #637768;
}

.AlignmentData-module__secondary-border-l___Gxm3f {
  border-left: 1px solid #637768;
}

.AlignmentData-module__secondary-border-r___B6Odh {
  border-right: 1px solid #637768;
}

.AlignmentData-module__gap-0___QkId8 {
  gap: 0 !important;
}

.AlignmentData-module__gap-2___g8fK_ {
  gap: 2px !important;
}

.AlignmentData-module__gap-4___QdLxq {
  gap: 4px !important;
}

.AlignmentData-module__gap-5___IsfAa {
  gap: 5px !important;
}

.AlignmentData-module__gap-6___nOjO3 {
  gap: 6px !important;
}

.AlignmentData-module__gap-8___DQ57P {
  gap: 8px !important;
}

.AlignmentData-module__gap-10___TaNqT {
  gap: 10px !important;
}

.AlignmentData-module__gap-12___R6TwA {
  gap: 12px !important;
}

.AlignmentData-module__gap-14___GcHai {
  gap: 14px !important;
}

.AlignmentData-module__gap-16___vQo4n {
  gap: 16px !important;
}

.AlignmentData-module__gap-18___ET9kF {
  gap: 18px !important;
}

.AlignmentData-module__gap-20___OqxFp {
  gap: 20px !important;
}

.AlignmentData-module__gap-24___o6cdm {
  gap: 24px !important;
}

.AlignmentData-module__gap-26___JmAhc {
  gap: 26px !important;
}

.AlignmentData-module__gap-30___mahgp {
  gap: 30px !important;
}

.AlignmentData-module__gap-32___aiIaP {
  gap: 32px !important;
}

.AlignmentData-module__gap-40___SEoix {
  gap: 40px !important;
}

.AlignmentData-module__gap-50___KHQwo {
  gap: 50px !important;
}

.AlignmentData-module__flex-1___b2Fd_ {
  flex: 1;
}

.AlignmentData-module__flex-none___UhU9w {
  flex: none !important;
}

.AlignmentData-module__flex-column___ssgnK {
  display: flex;
  flex-direction: column !important;
}

.AlignmentData-module__flex-row___sygfX {
  display: flex;
  flex-direction: row !important;
}

.AlignmentData-module__vertically-centered___HWa9u {
  display: flex;
  align-items: center !important;
}

.AlignmentData-module__horizontally-centered___Ycu1z {
  display: flex;
  justify-content: center !important;
}

.AlignmentData-module__horizontally-end___tgbUE {
  display: flex;
  justify-content: end !important;
}

.AlignmentData-module__vertically-start___a6ngn {
  display: flex;
  align-items: start !important;
}

.AlignmentData-module__space-between___JG3rb {
  display: flex;
  justify-content: space-between !important;
}

.AlignmentData-module__flex-wrap___NWU2U {
  flex-wrap: wrap !important;
}

.AlignmentData-module__height-100___h8HhC {
  height: 100%;
}

.AlignmentData-module__width-50___uFAZC {
  width: 50% !important;
}

.AlignmentData-module__width-100___RnJvG {
  width: 100%;
}

.AlignmentData-module__cursor-pointer___RNKtN {
  cursor: pointer;
}

.AlignmentData-module__cursor-not-allowed___ugV7T {
  cursor: not-allowed !important;
}

.AlignmentData-module__absolute-centered___J3aPT {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.AlignmentData-module__absolute___fQEjE {
  position: absolute;
}

.AlignmentData-module__relative___IbsiO {
  position: relative;
}

.AlignmentData-module__fixed___t7NSV {
  position: fixed;
}

.AlignmentData-module__visible___eGfop {
  opacity: 1;
}

.AlignmentData-module__invisible___Sj032 {
  opacity: 0;
}

.AlignmentData-module__col-90___oLDWp {
  width: 90% !important;
}

.AlignmentData-module__col-auto___bshJt {
  width: auto !important;
}

.AlignmentData-module__medical-tabs___CkENU {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.AlignmentData-module__medical-table-new____pihX {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AlignmentData-module__medical-table-new____pihX:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AlignmentData-module__medical-table-new____pihX::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AlignmentData-module__medical-table-new____pihX::-webkit-scrollbar-track {
  display: none;
}
.AlignmentData-module__medical-table-new____pihX.AlignmentData-module__no-pagination___qoYIn {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AlignmentData-module__medical-table-new____pihX.AlignmentData-module__no-pagination___qoYIn:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AlignmentData-module__medical-table-new____pihX.AlignmentData-module__no-pagination___qoYIn::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AlignmentData-module__medical-table-new____pihX.AlignmentData-module__no-pagination___qoYIn::-webkit-scrollbar-track {
  display: none;
}

.AlignmentData-module__medical-table-empty___BlbRM {
  padding: 14px 40px !important;
}

.AlignmentData-module__icon-btn___cIELG {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.AlignmentData-module__search-icon___QD8eJ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.AlignmentData-module__disable-select___LDHoG {
  user-select: none;
}

.AlignmentData-module__break-word___bSspF {
  word-break: break-word;
}

.AlignmentData-module__popup-clear-btn___Mh8u3 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.AlignmentData-module__scroll-m-b-20___jWcvk {
  scroll-margin-bottom: 20px;
}

.AlignmentData-module__wrapper___MoWU8 {
  height: calc(100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer));
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 25px 30px;
}
.AlignmentData-module__wrapper___MoWU8:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AlignmentData-module__wrapper___MoWU8::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AlignmentData-module__wrapper___MoWU8::-webkit-scrollbar-track {
  display: none;
}
.AlignmentData-module__wrapper___MoWU8 .AlignmentData-module__row___vjdEa {
  padding: 8px 0;
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}
.AlignmentData-module__wrapper___MoWU8 .AlignmentData-module__row___vjdEa:last-child {
  border-bottom: none;
}
.AlignmentData-module__wrapper___MoWU8 .AlignmentData-module__row___vjdEa .AlignmentData-module__label___Nmaf2 {
  color: #375844;
  width: 240px;
  flex-shrink: 0;
}
.AlignmentData-module__wrapper___MoWU8 .AlignmentData-module__row___vjdEa .AlignmentData-module__value___TWNez {
  color: #6d7278;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/AlignmentData/AlignmentData.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;ECQE,2GDNE;ECOF,kBAAA;EACA,kBAAA;EDJA,kBAAA;AA4pBF;ACtpBE;EACE,oCAAA;EACA,mBAAA;ADwpBJ;ACrpBE;EACE,UAAA;EACA,6BAAA;ADupBJ;ACppBE;EACE,aAAA;ADspBJ;AArqBE;EACE,cAAA;EACA,8CAAA;AAuqBJ;AArqBI;EACE,mBAAA;AAuqBN;AApqBI;EACE,cAAA;EACA,YAAA;EACA,cAAA;AAsqBN;AAnqBI;EACE,cAAA;EACA,sBAAA;AAqqBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.wrapper {\n  @include verticalScroll(\n    calc(\n      100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer)\n    )\n  );\n  padding: 25px 30px;\n\n  .row {\n    padding: 8px 0;\n    border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    .label {\n      color: get-color(greenNew, dark);\n      width: 240px;\n      flex-shrink: 0;\n    }\n\n    .value {\n      color: get-color(gray, dark);\n      word-break: break-word;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `AlignmentData-module__font-s-10___ckCS_`,
	"fontS12": `AlignmentData-module__font-s-12___ExBx4`,
	"fontS13": `AlignmentData-module__font-s-13___cIVyn`,
	"fontS14": `AlignmentData-module__font-s-14___drJYM`,
	"fontS15": `AlignmentData-module__font-s-15___vlAGI`,
	"fontS16": `AlignmentData-module__font-s-16___KPIH9`,
	"fontS18": `AlignmentData-module__font-s-18___BnYgN`,
	"fontS20": `AlignmentData-module__font-s-20___YPVDd`,
	"fontS22": `AlignmentData-module__font-s-22___zeZm_`,
	"fontS28": `AlignmentData-module__font-s-28___vBbtY`,
	"fontW400": `AlignmentData-module__font-w-400___Jijur`,
	"fontW500": `AlignmentData-module__font-w-500___T6FDp`,
	"fontW600": `AlignmentData-module__font-w-600___fHF1b`,
	"fontW700": `AlignmentData-module__font-w-700___bsLPP`,
	"p5": `AlignmentData-module__p-5___ie6Fj`,
	"p12": `AlignmentData-module__p-12___WyWM9`,
	"p16": `AlignmentData-module__p-16___Dh68Q`,
	"p30": `AlignmentData-module__p-30___n0HNn`,
	"pB0": `AlignmentData-module__p-b-0___ufUq0`,
	"pB5": `AlignmentData-module__p-b-5___Bl65q`,
	"pB10": `AlignmentData-module__p-b-10___H6L4f`,
	"pB12": `AlignmentData-module__p-b-12___xl7ZE`,
	"pB16": `AlignmentData-module__p-b-16___kj_rE`,
	"pB18": `AlignmentData-module__p-b-18___q4R3Z`,
	"pB20": `AlignmentData-module__p-b-20____h8xt`,
	"pB25": `AlignmentData-module__p-b-25___sqffR`,
	"pB30": `AlignmentData-module__p-b-30___RaFfb`,
	"pB50": `AlignmentData-module__p-b-50___yXL7X`,
	"pT0": `AlignmentData-module__p-t-0___fpGtJ`,
	"pT12": `AlignmentData-module__p-t-12___sWD_q`,
	"pT16": `AlignmentData-module__p-t-16___Yqkyc`,
	"pT18": `AlignmentData-module__p-t-18___rxoez`,
	"pT20": `AlignmentData-module__p-t-20___YT6B2`,
	"pT30": `AlignmentData-module__p-t-30___y5PKb`,
	"pT40": `AlignmentData-module__p-t-40___qr71g`,
	"pT50": `AlignmentData-module__p-t-50___zQrSn`,
	"pL20": `AlignmentData-module__p-l-20___akMpa`,
	"pL30": `AlignmentData-module__p-l-30___nNfrF`,
	"pL40": `AlignmentData-module__p-l-40___pKWUG`,
	"pR16": `AlignmentData-module__p-r-16___m1WQl`,
	"pR20": `AlignmentData-module__p-r-20___QTL2o`,
	"pR30": `AlignmentData-module__p-r-30___rzCQC`,
	"pR50": `AlignmentData-module__p-r-50___aZ1yl`,
	"pR60": `AlignmentData-module__p-r-60___uPuD3`,
	"mB1": `AlignmentData-module__m-b-1___HGak1`,
	"mB2": `AlignmentData-module__m-b-2___nhVvt`,
	"mB6": `AlignmentData-module__m-b-6___VIjwJ`,
	"mB8": `AlignmentData-module__m-b-8___pP6KZ`,
	"mB10": `AlignmentData-module__m-b-10___cTYWf`,
	"mB14": `AlignmentData-module__m-b-14___vKCZt`,
	"mB16": `AlignmentData-module__m-b-16___ROH8J`,
	"mB20": `AlignmentData-module__m-b-20___FmAoJ`,
	"mB22": `AlignmentData-module__m-b-22___lrM_1`,
	"mB24": `AlignmentData-module__m-b-24___yS43O`,
	"mB30": `AlignmentData-module__m-b-30___p69Pn`,
	"mB32": `AlignmentData-module__m-b-32___OTpit`,
	"mB40": `AlignmentData-module__m-b-40___lyxdm`,
	"mT2": `AlignmentData-module__m-t-2___M4dAk`,
	"mT3": `AlignmentData-module__m-t-3___o9KXv`,
	"mT4": `AlignmentData-module__m-t-4___kLIgV`,
	"mT5": `AlignmentData-module__m-t-5___S0qoM`,
	"mT8": `AlignmentData-module__m-t-8___nAsxR`,
	"mT10": `AlignmentData-module__m-t-10___M88nu`,
	"mT15": `AlignmentData-module__m-t-15____SWv_`,
	"mT16": `AlignmentData-module__m-t-16___iJ0ue`,
	"mT20": `AlignmentData-module__m-t-20___BmJGX`,
	"mT22": `AlignmentData-module__m-t-22___NNDea`,
	"mT30": `AlignmentData-module__m-t-30___hOb_k`,
	"mT32": `AlignmentData-module__m-t-32___yJpr2`,
	"mLAuto": `AlignmentData-module__m-l-auto___B0WBl`,
	"mL4": `AlignmentData-module__m-l-4___cYMzR`,
	"mL5": `AlignmentData-module__m-l-5___TCz14`,
	"mL6": `AlignmentData-module__m-l-6___lR9rL`,
	"mL8": `AlignmentData-module__m-l-8___l21c1`,
	"mL10": `AlignmentData-module__m-l-10___Dufvb`,
	"mL16": `AlignmentData-module__m-l-16___YCnXO`,
	"mL20": `AlignmentData-module__m-l-20___ax7Gt`,
	"mL24": `AlignmentData-module__m-l-24___IYeSV`,
	"mL30": `AlignmentData-module__m-l-30___F8hFp`,
	"mL35": `AlignmentData-module__m-l-35___i_k6V`,
	"mL40": `AlignmentData-module__m-l-40___qCaZ3`,
	"mR8": `AlignmentData-module__m-r-8___TDwW5`,
	"mR10": `AlignmentData-module__m-r-10___wGqB6`,
	"mR16": `AlignmentData-module__m-r-16___kgQ5M`,
	"mR20": `AlignmentData-module__m-r-20___w_mNZ`,
	"mR24": `AlignmentData-module__m-r-24___BFxpd`,
	"mR30": `AlignmentData-module__m-r-30___TFxdw`,
	"mR40": `AlignmentData-module__m-r-40___uCriP`,
	"borderR3": `AlignmentData-module__border-r-3___bPAln`,
	"borderR4": `AlignmentData-module__border-r-4___PwTTi`,
	"borderR6": `AlignmentData-module__border-r-6___zBeeP`,
	"borderR10": `AlignmentData-module__border-r-10___EqSqh`,
	"borderR12": `AlignmentData-module__border-r-12___VJjPH`,
	"borderR16": `AlignmentData-module__border-r-16___RGMJC`,
	"borderR50": `AlignmentData-module__border-r-50___MnRfm`,
	"primaryBorder": `AlignmentData-module__primary-border___xS_af`,
	"primaryBorderB": `AlignmentData-module__primary-border-b___t1Cmt`,
	"primaryBorderT": `AlignmentData-module__primary-border-t___cHkOH`,
	"primaryBorderL": `AlignmentData-module__primary-border-l___SrXkK`,
	"primaryBorderR": `AlignmentData-module__primary-border-r___M4iKH`,
	"secondaryBorder": `AlignmentData-module__secondary-border____JBU8`,
	"secondaryBorderB": `AlignmentData-module__secondary-border-b___R1AlQ`,
	"secondaryBorderT": `AlignmentData-module__secondary-border-t___UNiop`,
	"secondaryBorderL": `AlignmentData-module__secondary-border-l___Gxm3f`,
	"secondaryBorderR": `AlignmentData-module__secondary-border-r___B6Odh`,
	"gap0": `AlignmentData-module__gap-0___QkId8`,
	"gap2": `AlignmentData-module__gap-2___g8fK_`,
	"gap4": `AlignmentData-module__gap-4___QdLxq`,
	"gap5": `AlignmentData-module__gap-5___IsfAa`,
	"gap6": `AlignmentData-module__gap-6___nOjO3`,
	"gap8": `AlignmentData-module__gap-8___DQ57P`,
	"gap10": `AlignmentData-module__gap-10___TaNqT`,
	"gap12": `AlignmentData-module__gap-12___R6TwA`,
	"gap14": `AlignmentData-module__gap-14___GcHai`,
	"gap16": `AlignmentData-module__gap-16___vQo4n`,
	"gap18": `AlignmentData-module__gap-18___ET9kF`,
	"gap20": `AlignmentData-module__gap-20___OqxFp`,
	"gap24": `AlignmentData-module__gap-24___o6cdm`,
	"gap26": `AlignmentData-module__gap-26___JmAhc`,
	"gap30": `AlignmentData-module__gap-30___mahgp`,
	"gap32": `AlignmentData-module__gap-32___aiIaP`,
	"gap40": `AlignmentData-module__gap-40___SEoix`,
	"gap50": `AlignmentData-module__gap-50___KHQwo`,
	"flex1": `AlignmentData-module__flex-1___b2Fd_`,
	"flexNone": `AlignmentData-module__flex-none___UhU9w`,
	"flexColumn": `AlignmentData-module__flex-column___ssgnK`,
	"flexRow": `AlignmentData-module__flex-row___sygfX`,
	"verticallyCentered": `AlignmentData-module__vertically-centered___HWa9u`,
	"horizontallyCentered": `AlignmentData-module__horizontally-centered___Ycu1z`,
	"horizontallyEnd": `AlignmentData-module__horizontally-end___tgbUE`,
	"verticallyStart": `AlignmentData-module__vertically-start___a6ngn`,
	"spaceBetween": `AlignmentData-module__space-between___JG3rb`,
	"flexWrap": `AlignmentData-module__flex-wrap___NWU2U`,
	"height100": `AlignmentData-module__height-100___h8HhC`,
	"width50": `AlignmentData-module__width-50___uFAZC`,
	"width100": `AlignmentData-module__width-100___RnJvG`,
	"cursorPointer": `AlignmentData-module__cursor-pointer___RNKtN`,
	"cursorNotAllowed": `AlignmentData-module__cursor-not-allowed___ugV7T`,
	"absoluteCentered": `AlignmentData-module__absolute-centered___J3aPT`,
	"absolute": `AlignmentData-module__absolute___fQEjE`,
	"relative": `AlignmentData-module__relative___IbsiO`,
	"fixed": `AlignmentData-module__fixed___t7NSV`,
	"visible": `AlignmentData-module__visible___eGfop`,
	"invisible": `AlignmentData-module__invisible___Sj032`,
	"col90": `AlignmentData-module__col-90___oLDWp`,
	"colAuto": `AlignmentData-module__col-auto___bshJt`,
	"medicalTabs": `AlignmentData-module__medical-tabs___CkENU`,
	"medicalTableNew": `AlignmentData-module__medical-table-new____pihX`,
	"noPagination": `AlignmentData-module__no-pagination___qoYIn`,
	"medicalTableEmpty": `AlignmentData-module__medical-table-empty___BlbRM`,
	"iconBtn": `AlignmentData-module__icon-btn___cIELG`,
	"searchIcon": `AlignmentData-module__search-icon___QD8eJ`,
	"disableSelect": `AlignmentData-module__disable-select___LDHoG`,
	"breakWord": `AlignmentData-module__break-word___bSspF`,
	"popupClearBtn": `AlignmentData-module__popup-clear-btn___Mh8u3`,
	"scrollMB20": `AlignmentData-module__scroll-m-b-20___jWcvk`,
	"wrapper": `AlignmentData-module__wrapper___MoWU8`,
	"row": `AlignmentData-module__row___vjdEa`,
	"label": `AlignmentData-module__label___Nmaf2`,
	"value": `AlignmentData-module__value___TWNez`
};
module.exports = ___CSS_LOADER_EXPORT___;
